import { render, staticRenderFns } from "./CreateSales.vue?vue&type=template&id=29132ac6&scoped=true&lang=pug&"
import script from "./CreateSales.vue?vue&type=script&lang=ts&"
export * from "./CreateSales.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29132ac6",
  null
  
)

export default component.exports